import React from 'react';
import TextInput from './components/TextInput';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import { Controller, useFormContext } from 'react-hook-form';
import { useWizard } from 'rhf-wizard';
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginFileValidateSize from "filepond-plugin-file-validate-size";
import TextArea from './components/TextArea';
import SimpleCheckbox from './components/SimpleCheckbox';
import ErrorPanel from './components/ErrorMessage';
import CustomScroll from './components/CustomScroll';
registerPlugin(FilePondPluginFileValidateType, FilePondPluginFileValidateSize);
const Step6 = () => {
    const { isLoading, setIsLoading } = useWizard();
    const { control } = useFormContext();
    return (React.createElement(CustomScroll, null,
        React.createElement("div", { className: "modal-grid step-6" },
            React.createElement("div", { className: "modal-left-column" },
                React.createElement("h2", null, "Final step - Your details"),
                React.createElement("p", null, "Your quote request is almost ready. Please provide your contact details so we can get started"),
                React.createElement("div", { className: "quote-form-grid" },
                    React.createElement("div", { className: "form-group mb-0" },
                        React.createElement(TextInput, { name: "name", placeholder: "* Your first name" })),
                    React.createElement("div", { className: "form-group mb-0" },
                        React.createElement(TextInput, { name: "email", placeholder: "* Your email" })),
                    React.createElement("div", { className: "form-group mb-0" },
                        React.createElement(TextInput, { name: "organisation", placeholder: "* Organisation name" })),
                    React.createElement("div", { className: "form-group mb-0" },
                        React.createElement(TextInput, { name: "phone", placeholder: "Your phone number" })),
                    React.createElement(TextArea, { name: "additional", placeholder: "Additional information" }),
                    React.createElement(Controller, { name: "attachment", control: control, render: ({ field }) => (React.createElement(FilePond, { allowMultiple: false, maxFiles: 1, server: {
                                url: "/ajax/file-upload.php",
                            }, onprocessfilestart: () => setIsLoading(true), onprocessfile: (error, file) => {
                                field.onChange(file.serverId);
                                setIsLoading(false);
                            }, onremovefile: () => {
                                field.onChange("");
                            }, name: "fileUpload", credits: false, allowFileSizeValidation: true, maxFileSize: "100MB", chunkForce: true, chunkUploads: true, chunkSize: 5 * 1000 * 1000, labelIdle: "<p>Attachment</p><p><small>Add a file with a maximum size of 10Mb<br />in the following formats: .pdf, .doc, .docx, .odt or .rtf</small></p><span class=\"filepond--label-action btn btn-blue-reverse\">Import</span>", allowFileTypeValidation: true, acceptedFileTypes: [
                                //pdf
                                "application/pdf",
                                //dox
                                "application/msword",
                                //docx
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                //odt
                                "application/vnd.oasis.opendocument.text",
                                //rtf
                                "application/rtf"
                            ] })) }),
                    React.createElement(SimpleCheckbox, { name: "acceptTerms", value: "true" },
                        React.createElement("span", null,
                            "I accept ",
                            React.createElement("a", { href: "/terms", target: "_blank" }, "Terms & Conditions"))),
                    React.createElement(ErrorPanel, { name: "acceptTerms" }))),
            React.createElement("div", { className: "modal-right-column" },
                React.createElement("img", { width: "600", height: "600", src: "/assets/images/quote-modal/final-steps-v2.webp", alt: "Parametrix Documents", className: "img-fluid right-col-image", loading: "lazy" })))));
};
export default Step6;
